import { render, staticRenderFns } from "./IntervoiceStart.vue?vue&type=template&id=335aea2d"
import script from "./IntervoiceStart.vue?vue&type=script&lang=js"
export * from "./IntervoiceStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports